import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import DOMPurify from "dompurify";

@Pipe({
  name: "safeHtml",
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    const clean = DOMPurify.sanitize(value ?? "");
    return this.sanitizer.bypassSecurityTrustHtml(clean); // NOSONAR - Content is explicitly sanitized by DOMPurify before being marked as trusted
  }
}
